// src/index.ts
import { flare } from "@flareapp/js";
import { Component } from "react";
var FlareErrorBoundary = class extends Component {
  componentDidCatch(error, reactErrorInfo) {
    const context = {
      react: {
        componentStack: formatReactComponentStack(reactErrorInfo?.componentStack ?? "")
      }
    };
    flare.report(error, context, { react: { errorInfo: reactErrorInfo } });
  }
  render() {
    return this.props.children;
  }
};
function formatReactComponentStack(stack) {
  return stack.split(/\s*\n\s*/g).filter((line) => line.length > 0);
}
export {
  FlareErrorBoundary
};
